<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse"
            data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a class="navbar-brand" href="#">
      <img src="../assets/logo_drop_only.png" width="30" alt="">
    </a>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active">
          <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/api/report">Board Memo</a>
        </li>
                <li class="nav-item">
          <a class="nav-link" title="Download CSV" href="/api/report?type=csv"><i class="fa fa-download"></i></a>
        </li>
      </ul>
      <auth-login></auth-login>
      <new-record-button></new-record-button>
      <global-variables></global-variables>
      <form id="search" class="form-inline my-2 my-lg-0">
        <search-box></search-box>
      </form>
    </div>
  </nav>
</template>

<script>
import SearchBox from "./SearchBox";
import AuthLogin from "./AuthLogin";
import NewRecordButton from "./NewRecordButton";
import GlobalVariables from "./GlobalVariables";
export default {
  name: "main-nav",
  components: { SearchBox, AuthLogin, GlobalVariables, NewRecordButton }
};
</script>
